import React, { useEffect, useState } from "react";
import { RootState } from "../utils/redux/store";
import { useAppSelector } from "../utils/redux/hooks";
import socket from "../utils/socket";

const UseTrackNewChatAndOrder = () => {
  const chats = useAppSelector((store: RootState) => store.user.chats);
  const newOrders = useAppSelector((store: RootState) => store.user.orders);

  const [hasNewMessage, setHasNewMessage] = useState<boolean>(false);
  const [hasNewOrder, setHasNewOrder] = useState<boolean>(false);

  useEffect(() => {
    const checkForNewMessages = () => {
      const latestSeenChatDateString = localStorage.getItem("lastSeenChat");
      const latestSeenChatDate = latestSeenChatDateString
        ? JSON.parse(latestSeenChatDateString)
        : null;

      const firstChatDate = chats[0]?.updatedAt;

      if (
        firstChatDate &&
        latestSeenChatDate &&
        new Date(firstChatDate) > new Date(latestSeenChatDate)
      ) {
        setHasNewMessage(true);
      } else {
        setHasNewMessage(false);
      }
    };

    checkForNewMessages();
  }, [chats]);

  useEffect(() => {
    const checkForNewOrders = () => {
      const latestSeenOrderDateString = localStorage.getItem(
        "lastestSeenOrderDate"
      );
      const latestSeenOrderDate = latestSeenOrderDateString
        ? JSON.parse(latestSeenOrderDateString)
        : null;

      const firstOrderDate = newOrders[0]?.createdAt;

      if (
        firstOrderDate &&
        latestSeenOrderDate &&
        new Date(firstOrderDate) > new Date(latestSeenOrderDate)
      ) {
        setHasNewOrder(true);
      } else {
        setHasNewOrder(false);
      }
    };

    checkForNewOrders();
  }, [newOrders]);

  return { hasNewMessage, hasNewOrder };
};

export default UseTrackNewChatAndOrder;
